module.exports = __webpack_public_path__ + "img/video-small-2.e00ca9d1.svg";